import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Panel from 'beam/dist/Panel'
import BeamIcon from 'beam/dist/BeamIcon'
import { withStyles } from 'beam/dist/styles'
import SeekBar from '../SeekBar'
import ErrorBoundary from '../ErrorBoundary'

const dataTestIdPrefix = 'App-Recordings-MediaPlayer-Timeline-'

const styles = theme => ({
  panelRoot: {
    zIndex: 99,
    boxShadow: 'none',
  },
  panelBody: {
    padding: theme.spacing(1, 0),
    paddingLeft: 6,
    height: `calc(100% - ${theme.spacing(4)}px)`,
  },
})

const TimelinePanel = ({
  classes,
  t,
  contactId,
  duration,
  currentTime,
  timeMarkerWidth,
  isZoomed,
  onScrubStart,
  onScrubEnd,
}) => {
  return (
    <Panel
      dense
      titleIcon={<BeamIcon>Altimeter</BeamIcon>}
      titleIconTooltipText={t(['timeline', 'Timeline'])}
      variant="light"
      headerTestId={`${dataTestIdPrefix}panel-heading`}
      classes={{ root: classes.panelRoot, body: classes.panelBody }}
    >
      <ErrorBoundary key={contactId}>
        <SeekBar
          variant="dark"
          duration={duration}
          currentTime={currentTime}
          timeMarkerWidth={timeMarkerWidth}
          isZoomed={isZoomed}
          onScrubStart={onScrubStart}
          onScrubEnd={onScrubEnd}
        />
      </ErrorBoundary>
    </Panel>
  )
}

TimelinePanel.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  contactId: PropTypes.number.isRequired,
  /** Total length of media in milliseconds */
  duration: PropTypes.number,
  /** Current playback time in milliseconds */
  currentTime: PropTypes.number,
  /** Width of the red time marker line */
  timeMarkerWidth: PropTypes.number.isRequired,
  /** Is the media player in zoomed mode or not */
  isZoomed: PropTypes.bool,
  /** Callback for when scrubbing starts */
  onScrubStart: PropTypes.func.isRequired,
  /** Callback for when scrubbing ends */
  onScrubEnd: PropTypes.func.isRequired,
}

TimelinePanel.defaultProps = {
  duration: 0,
  currentTime: 0,
  buffer: 0,
}

export { TimelinePanel as UnstyledTimelinePanel }
export default withStyles(styles)(withTranslation()(TimelinePanel))
